/*eslint no-template-curly-in-string: "off"*/
const waitHtml = require('./wait.html')
  .replace('${message}', gettext('Пожалуйста, подождите.'));

require('./frame-view.component.scss');

import {
  IS_IE_BROWSER
} from '../common/config.js';

class FrameViewController {
  constructor($scope,
    $timeout,
    $element,
    $compile,
    $http,
    $cookies,
    md5,
    rx,
    RouterService,
    FrameLoadService
  ) {
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$element = $element;
    this.$compile = $compile;
    this.RouterService = RouterService;
    this.FrameLoadService = FrameLoadService;
    this.$http = $http;
    this.$cookies = $cookies;
    this.md5 = md5;

    this.handleOnLoad = false;
    this.reload = false;

    this.$scope.$on('beforePrint', () => {
      this.beforePrint();
    });

    // $('sc-frame-view iframe').contents().on('click', e => jQuery( "body" ).trigger( jQuery.Event( "click" ) ))

    this.$scope.$on('afterPrint', () => {
      this.afterPrint();
    });
    const subscriptions = [
      rx.Observable.merge(
        $scope.$toObservable('$ctrl.src'),
        $scope.$toObservable('$ctrl.maximize'),
        $scope.$eventToObservable('reload')
        .do(() => {
          this.reload = true;
          //console.log('frame reload');
        }),
      )
      .debounce(200)
      .subscribe(() => {
        this.updateSrc();
      }),
    ];
    // $scope.$watch('$ctrl.src', (value) => {
    //   console.log('frame source changed', value);
    // });
    $scope.$on('$destroy', () => {
      subscriptions.forEach((s) => s.dispose());
      if (this.iframe) {
        this.FrameLoadService.removeFrame(this.iframe[0]);
      }
    });
  }

  $onInit() {}

  $onDestroy() {}

  updateSrc() {
    //console.log('frame update src');
    if (this.iframe) {
      const src = this.iframe[0].contentWindow.document.location.pathname +
        this.iframe[0].contentWindow.document.location.search;
      if (this.src === src && !this.reload) {
        return;
      }
      //console.log('frame removed');
      this.iframe[0].removeEventListener('load', this.onload);
      this.FrameLoadService.removeFrame(this.iframe[0]);
      this.iframe.remove();
      this.iframe = null;
    }
    this.reload = false;
    if (!this.src || typeof this.maximize === 'undefined') {
      return;
    }
    if (this.maximize) {
      this.iframe = angular.element(
        '<iframe id= "iframe" frameborder="0" scrolling="no"></iframe>');
    } else {
      this.iframe = angular.element(
        '<iframe id= "iframe" frameborder="0" class="maximize"></iframe>');
    }
    this.$element.append(this.iframe);
    const frame = this.iframe[0];
    this.FrameLoadService.addFrame(frame);
    frame.contentWindow.document.body.innerHTML = waitHtml;
    frame.RouterService = this.RouterService;

    if (IS_IE_BROWSER) {

      // For IE we doing following trick:
      // POST QueryString to separate handler with by md5 hash as key
      // This handler will store QueryString to cache
      // After that load frame with ?hash=XXXX param
      // This param handled by django middleware and change request.GET to cached value

      const parts = this.src.split('?');
      const url = parts[0];
      const body = parts[1];

      if (body) {
        const hash = this.md5.createHash(body);
        const req_params = {};

        req_params['headers'] = {
          'X-CSRFToken': this.$cookies.get('csrftoken'),
          'Content-Type': 'application/x-www-form-urlencoded',
        };

        this.$http.post('/analytics/reg_body/?h=' + hash, body, req_params).then(({
          data,
          status,
          headers,
          config
        }) => {
          frame.src = url + '?hash=' + hash;
        });
      } else {
        frame.src = this.src;
      }

    } else {
      frame.src = this.src;
    }

    this.onload = () => {

      //***************************************** // in order to close menu
      frame.contentWindow.document.addEventListener('click', e => {
        const newHeight = `${frame.contentWindow.document.firstElementChild.offsetHeight}px`;
        // if (newHeight !== frame.style.minHeight) frame.style.minHeight = newHeight;
        $('body sc-header').trigger($.Event('mousedown')).trigger($.Event('click')); // in order to close menu

      });

      if (this.onFrameLoad) {
        this.onFrameLoad({
          frame
        });
      }

      frame.setAttribute('sc-loaded', true);
      if (this.maximize) {
        frame.style['min-height'] = Math.max(
          this.minHeight || 0,
          frame.contentDocument.body.scrollHeight,
        ) + 'px';
        frame.style['min-width'] = frame.contentDocument.body.scrollWidth + 'px';
      }
      if (!frame.contentWindow) {
        return;
      }

      if (this.handleOnLoad) {
        const src = frame.contentWindow.document.location.pathname +
          frame.contentWindow.document.location.search;
        if (this.src !== src) {
          this.src = src;
          this.RouterService.openFrame(src);
          this.$scope.$root.$digest();
        }

        frame.contentWindow.document.addEventListener('click', (e) => {
          $('body sc-header').trigger($.Event('mousedown')).trigger($.Event('click')); // in order to close menu
          let node = e.target;
          while (node && node.localName !== 'a') {
            node = node.parentNode;
          }
          if (node && node.href &&
            (node.href.startsWith('/') || node.href.startsWith('http'))) {
            const src = node.pathname + node.search;
            this.RouterService.openFrame(src);
            e.preventDefault();
            this.$scope.$root.$digest();
            return false; // stop handling the click
          }
          return true;
        });
      }
    };

    this.iframe[0].addEventListener('load', this.onload, false);

    if (this.onFrameCreate) {
      this.onFrameCreate({
        frame
      });
    }
  }

  beforePrint() {
    if (!this.iframe) {
      return;
    }
    if (this.maximize) {
      this.iframe[0].style.height = this.iframe[0].contentDocument.body.scrollHeight + 'px';
      this.iframe[0].style.width = this.iframe[0].contentDocument.body.scrollWidth + 'px';
      this.iframe[0].setAttribute('scrolling', 'no');
    } else {
      this.iframe[0].style.height = (this.iframe.width() * 0.618) + 'px';
    }
  }

  afterPrint() {
    if (!this.iframe) {
      return;
    }
    this.iframe[0].style.removeProperty('height');
    this.iframe[0].style.removeProperty('width');
    if (this.maximize) {
      this.iframe[0].removeAttribute('scrolling');
    }
  }
}

export const FrameViewComponent = {
  template: require('./frame-view.component.html'),
  bindings: {
    src: '<',
    maximize: '<',
    minHeight: '<?',
    onFrameCreate: '&?',
    onFrameLoad: '&?',
    handleOnLoad: '<?',
  },
  controller: FrameViewController,
};



// WEBPACK FOOTER //
// ./src/view/frame-view.component.js